module.exports = __webpack_public_path__ + "img/image_add.1d637982.png";